import { render, staticRenderFns } from "./relatedProducts.vue?vue&type=template&id=2ed16bfe&scoped=true&"
import script from "./relatedProducts.vue?vue&type=script&lang=js&"
export * from "./relatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./relatedProducts.vue?vue&type=style&index=0&id=2ed16bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed16bfe",
  null
  
)

export default component.exports